
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { ErrorMessage } from '@/store'

@Component
export default class ErrorPage extends Vue {
  @Prop() readonly errorMessage!: ErrorMessage;
}
